import { Box } from "@mui/material";

function VideoHero() {
    return (
        <Box
            sx={{
                width: { xs: "100%", lg: "1440px" },
                mx: "auto",
                position: "relative",
                pt: "56.25%",
                borderRadius: { xs: 0, md: 2 },
                overflow: "hidden",
                boxShadow: { md: 3 },
                backgroundColor: "#000",
            }}
        >
            <Box
                component="iframe"
                title="Vídeo institucional"
                src="https://www.youtube.com/embed/sFwuduIv1Zc?rel=0&modestbranding=1&playsinline=1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    border: 0,
                }}
            />
        </Box>
    );
}

export default VideoHero;